import PropTypes from 'prop-types';
import statsType from './stats';

export const statsMainType = PropTypes.exact({
  classNames: PropTypes.string.isRequired,
  stats: statsType.isRequired,
});

export const statsTotalType = statsMainType;

export const statsLevelsType = statsMainType;
